import { toast } from 'sonner'
import { useEffect, useState } from 'react'
import axios, { endpoints } from '@/lib/axios'
import { PaginationMeta, PaginateResponse } from '@/utils/paginate'
import CustomPagination from '@/components/pagination/custom-pagination'
import LoadingSection from '@/components/loading-indicator/loading-section'

import OrderPrivilegeTable from '../order-privilege-table'
import { type OrderPrivilege } from '../order-privilege.types'
import OrderPrivilegeFilter, {
  type OrderPrivilegeFilters,
} from '../order-privilege-filter'

const PAGE_SIZE = 10

export default function OrderPrivilegeView() {
  const [loading, setLoading] = useState(true)
  const [orders, setOrders] = useState<OrderPrivilege[]>([])
  const [pageMeta, setPageMeta] = useState<PaginationMeta>({
    limit: PAGE_SIZE,
    page: 1,
    total: 0,
  })
  const [filters, setFilters] = useState<OrderPrivilegeFilters>({
    page: 1,
    limit: PAGE_SIZE,
    status: undefined,
    shippingStatus: undefined,
    paymentStatus: undefined,
    paymentType: undefined,
    orderBy: 'createdAt:desc',
  })

  const fetchOrders = async () => {
    try {
      setLoading(true)
      const { data } = await axios.get<PaginateResponse<OrderPrivilege>>(
        endpoints.orderPrivileges.list,
        {
          params: {
            ...filters,
          },
        },
      )

      setOrders(data.items)
      setPageMeta({ limit: data.limit, page: data.page, total: data.total })
    } catch {
      toast.error('เกิดข้อผิดพลาดในการโหลดข้อมูล')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchOrders()
  }, [filters])

  const handlePageChange = (page: number) => {
    setFilters((prev) => ({ ...prev, page }))
  }

  const handleFiltersChange = (newFilters: Partial<OrderPrivilegeFilters>) => {
    setFilters((prev) => ({ ...prev, ...newFilters }))
  }

  // Table rendering moved to OrderPrivilegeTable

  return (
    <div className="w-full">
      <div className="space-y-6 mb-6">
        <OrderPrivilegeFilter
          filters={filters}
          onFiltersChange={handleFiltersChange}
        />
      </div>

      <LoadingSection loading={loading}>
        <OrderPrivilegeTable
          orders={orders}
          loading={loading}
          onOrderUpdated={fetchOrders}
        />

        {Math.ceil(pageMeta.total / pageMeta.limit) > 1 && (
          <div className="mt-6">
            <CustomPagination
              currentPage={pageMeta.page}
              totalPages={Math.ceil(pageMeta.total / pageMeta.limit)}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </LoadingSection>
    </div>
  )
}
